import * as React from 'react';



export default class multiCheck extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fillRule="evenodd" stroke="#B2B2B2">
                <path className="activeStroke" d="M17.686 17.102v1.97a.94.94 0 0 1-.94.94H5.54a.94.94 0 0 1-.94-.94V7.138a.94.94 0 0 1 .94-.94h1.582"/>
                <path className="activeFill activeStroke" d="M19.2 17.413H7.993a.94.94 0 0 1-.94-.94V4.539a.94.94 0 0 1 .94-.938H19.2c.52 0 .94.42.94.938v11.934a.94.94 0 0 1-.94.94z"/>
                <path className="activeCheck" d="M9.572 9.472l2.541 3.154 5.508-5.084"/>
            </g>
        </svg>
    
    )
  }
}
